import React, { useState } from "react";
import ReturnReplace from "./ReturnReplace";
import FinalConfirmation from "../your_order/CancelConfirmation";
import StepRefundPayment from "../your_order/StepRefundMethod";
import ReturnCOD from "./ReturnCOD";

const ReturnSteps = ({
  setIsReturn,
  orderID,
  orderData,
  refetch,
  setOpenOrder,
}) => {
  const [step, setStep] = useState(1);
  const [cancelReason, setCancelReason] = useState(null);
  const [additionalComments, setAdditionalComments] = useState("");
  const [refundMethod, setRefundMethod] = useState("");
  const [token, setToken] = useState(null);
  const handleNext = () => setStep((prev) => prev + 1);
  const handleBack = () => setStep((prev) => prev - 1);
  const [uploadedImage, setUploadedImage] = useState(null); // store uploaded image
  const [selectedQty, setSelectedQty] = useState(orderData?.quantity || "");

  return (
    <div className="max-w-[800px] mx-auto">
      {step === 1 && (
        <ReturnReplace
          pageTitle={"Return"}
          orderData={orderData}
          orderID={orderID}
          cancelReason={cancelReason}
          setCancelReason={setCancelReason}
          additionalComments={additionalComments}
          setAdditionalComments={setAdditionalComments}
          isReturn={true}
          setIsReturn={setIsReturn}
          onNext={handleNext}
          setStep={setStep}
          uploadedImage={uploadedImage}
          setUploadedImage={setUploadedImage}
          selectedQty={selectedQty}
          setSelectedQty={setSelectedQty}
        />
      )}

      {step === 2 && (
        <StepRefundPayment
          onNext={handleNext}
          refundMethod={refundMethod}
          setRefundMethod={setRefundMethod}
          setCancelReason={setCancelReason}
          additionalComments={additionalComments}
          setAdditionalComments={setAdditionalComments}
          cancelReason={cancelReason}
          onBack={handleBack}
          orderData={orderData}
          orderID={orderID}
          isReturn={true}
          setStep={setStep}
          setToken={setToken}
          selectedQty={selectedQty}
        />
      )}
      {step === 3 && (
        <FinalConfirmation
          setClose={setIsReturn}
          type={"Return"}
          refetch={refetch}
          setOpenOrder={setOpenOrder}
        />
      )}
      {step === 4 && (
        <ReturnCOD
          setClose={setIsReturn}
          token={token}
          refundMethod={refundMethod}
          orderID={orderID}
          orderData={orderData}
          setStep={setStep}
        />
      )}
    </div>
  );
};

export default ReturnSteps;
